module.exports = __webpack_public_path__ + "img/img73.2b760d19.png";